import React from 'react';
import { NavLink } from "react-router-dom";

const Independentlearning_k13_subjects = () => {
  return (
   <div className='fixed top-24 right-0 left-0 justify-items-stretch w-full content-center items-center'>
     <div className="h-12 flex bg-[#007bff] justify-between gap-4"> 
     
    
      <NavLink 
        to="/learning/independentlearning_k13/independentlearning_k13eng" 
        className={({ isActive }) =>
             isActive
               ? 'bg-blue-600 text-white rounded-md ' // Active styles
               : 'text-white hover:bg-[#fbc901] hover:text-white rounded-md ' // Inactive styles
           }
      >
        English Language Arts
      </NavLink>
      
      <NavLink 
        to="/learning/independentlearning_k13/independentlearning_k13math" 
        className={({ isActive }) =>
             isActive
               ? 'bg-blue-600 text-white rounded-md ' // Active styles
               : 'text-white hover:bg-[#fbc901] hover:text-white rounded-md ' // Inactive styles
           }
      >
        Mathematics
      </NavLink>
      
      <NavLink 
        to="/learning/independentlearning_k13/independentlearning_k13scie" 
        className={({ isActive }) =>
             isActive
               ? 'bg-blue-600 text-white rounded-md ' // Active styles
               : 'text-white hover:bg-[#fbc901] hover:text-white rounded-md ' // Inactive styles
           }
      >
        Science
      </NavLink>
      
      <NavLink 
        to="/learning/independentlearning_k13/independentlearning_k13soc" 
        className={({ isActive }) =>
             isActive
               ? 'bg-blue-600 text-white rounded-md ' // Active styles
               : 'text-white hover:bg-[#fbc901] hover:text-white rounded-md ' // Inactive styles
           }
      >
        Social Studies
      </NavLink>
      
    </div>
    </div>
  );
}

export default Independentlearning_k13_subjects;